import styled from 'styled-components'

import { Container } from '@/components/shared/Container'

import { EmailSubscribeWidget } from './EmailSubscribeWidget'

const StyledContainer = styled(Container)`
  width: 100%;
  max-width: 1200px;
  border-radius: 24px;
  padding: 72px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props) => props.theme.v2.surface.yellow};
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    margin: 0px;
  }
`
const StyledTextContent = styled.div`
  max-width: 736px;
  margin: 0;
  h2 {
    font-family: ${(props) => props.theme.v2.font.nantes};
    font-size: ${(props) => props.theme.v2.typography.display.l.fontSize};
    line-height: ${(props) => props.theme.v2.typography.display.l.lineHeight};
    text-align: center;
    margin: 0;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
      font-size: ${(props) => props.theme.v2.typography.display.s.fontSize};
      line-height: ${(props) => props.theme.v2.typography.display.s.lineHeight};
      margin: 0 0 32px;
    }
  }
  p {
    max-width: 640px;
    font-family: ${(props) => props.theme.v2.font.lotaGrotesqueLight};
    font-size: ${(props) => props.theme.v2.typography.body.m.fontSize};
    line-height: ${(props) => props.theme.v2.typography.body.m.lineHeight};
    text-align: center;
    justify-content: center;
    margin: 16px auto;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
      font-size: ${(props) => props.theme.v2.typography.body.s.fontSize};
      line-height: ${(props) => props.theme.v2.typography.body.s.lineHeight};
      margin: 0 0 32px;
    }
  }
`
const StyledNewsletterContainer = styled.div`
  min-width: 640px;
  display: flex;
  justify-content: center;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    padding: 0 96px;
    min-width: 90vw;
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    padding: 0 16px;
    min-width: 90vw;
  }
`

export const GutShotGetStartedSection = () => (
  <StyledContainer>
    <StyledTextContent>
      <h2>Get started with our free gut health guide</h2>
      <p>
        Take the first step towards improving your gut health with an exclusive series of emails and recipes, all backed
        by world-leading science.{' '}
      </p>
      <p>We will also send you ongoing gut health and nutrition insights, including how ZOE’s products could help.</p>
    </StyledTextContent>
    <StyledNewsletterContainer>
      <EmailSubscribeWidget
        includeAgreeToNewsletterSignup
        includePrivacyPolicy={false}
        buttonStyle="dark"
        postSignupMessageStyle="center"
      />
    </StyledNewsletterContainer>
  </StyledContainer>
)
